module.exports = __webpack_public_path__ + "static/brush2-114a67bf70cea81b5984551898f2bb81.png";